import React, { useState, useEffect } from "react";

import UserService from "../services/user.service";
import EventBus from "../common/EventBus";
import { Button, Card, Col, Container, Row } from "react-bootstrap/";
import DashboardCajas from "./DashboardCajas";

import MonetizationOn from "@mui/icons-material/MonetizationOn";
import FilterFrames from "@mui/icons-material/FilterFrames";
import Cloud from "@mui/icons-material/Cloud";
import Payments from "@mui/icons-material/Payments";
import PhotoLibrary from "@mui/icons-material/PhotoLibrary";
import Security from "@mui/icons-material/Security";
import Group from "@mui/icons-material/Group";

import { useNavigate } from "react-router-dom";
import "./boardAdmin.css";

const BoardAdmin = () => {
  const [content, setContent] = useState("");
  const [responseCode, setResponseCode] = useState("");
  const [activeTab, setActiveTab] = useState("cajas");

  const navigate = useNavigate();

  useEffect(() => {
    UserService.getAdminBoard().then(
      (response) => {
        setContent(response.data);
        setResponseCode(response.status);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setContent(_content);

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      }
    );
  }, []);

  const website = [
    "Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit",
    'Sign contract for "What are conference organizers afraid of?"',
  ];
  const server = [
    "Lines From Great Russian Literature? Or E-mails From My Boss?",
    "Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit",
    'Sign contract for "What are conference organizers afraid of?"',
  ];

  const permisosClicked = () => {
    navigate("/admin/permisos");
  };

  const usuariosClicked = () => {
    navigate("/admin/usuarios");
  };

  const cobrosClicked = () => {
    navigate("/admin/cobros");
  };

  const fotosArticulosClicked = () => {
    navigate("/admin/fotosarticulos");
  };

  const quickActions = [
    {
      key: "cobros",
      label: "Cobros",
      icon: Payments,
      onClick: cobrosClicked,
    },
    {
      key: "fotos",
      label: "Fotos",
      icon: PhotoLibrary,
      onClick: fotosArticulosClicked,
    },
    {
      key: "permisos",
      label: "Permisos",
      icon: Security,
      onClick: permisosClicked,
    },
    {
      key: "usuarios",
      label: "Usuarios",
      icon: Group,
      onClick: usuariosClicked,
    },
  ];

  const tabs = [
    { key: "cajas", label: "Cajas actuales", icon: MonetizationOn },
    //{ key: "pedidos", label: "Pedidos web", icon: FilterFrames },
    //{ key: "server", label: "Server", icon: Cloud },
  ];

  if (responseCode === 200) {
    return (
      <Container className="admin-mobile-root">
        <h3 className="admin-title">Administrador</h3>
        {content !== undefined && content !== "No token provided!" ? (
          <>
            <Card className="admin-surface mb-2">
              <Card.Body>
                <div className="admin-actions-grid">
                  {quickActions.map((action) => {
                    const Icon = action.icon;
                    return (
                      <Button
                        key={action.key}
                        variant="light"
                        className="admin-action-btn"
                        onClick={action.onClick}
                      >
                        <Icon style={{ fontSize: 20 }} />
                        <span>{action.label}</span>
                      </Button>
                    );
                  })}
                </div>
              </Card.Body>
            </Card>

            <Card className="admin-surface">
              <Card.Body>
                <div className="admin-tabs-wrap">
                  {tabs.map((tab) => {
                    const Icon = tab.icon;
                    const isActive = activeTab === tab.key;

                    return (
                      <Button
                        key={tab.key}
                        variant="light"
                        className={`admin-tab-btn ${isActive ? "active" : ""}`}
                        onClick={() => setActiveTab(tab.key)}
                      >
                        <Icon style={{ fontSize: 18 }} />
                        <span>{tab.label}</span>
                      </Button>
                    );
                  })}
                </div>

                <div className="admin-tab-content">
                  {activeTab === "cajas" ? (
                    <DashboardCajas />
                  ) : (
                    <Row className="g-2 g-md-3">
                      {(activeTab === "pedidos" ? website : server).map((item, index) => (
                        <Col xs={12} key={index}>
                          <Card className="admin-note-card">
                            <Card.Body>{item}</Card.Body>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  )}
                </div>
              </Card.Body>
            </Card>
          </>
        ) : null}
      </Container>
    );
  } else {
    return (
      <div className="container">
        <header className="jumbotron">
          <h3>{content}</h3>
        </header>
      </div>
    );
  }
};
export default BoardAdmin;
